/**
* Short Accordions JS
* -----------------------------------------------------------------------------
*
* All the JS for the Short Accordions component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'short-accordions',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.short-accordions__title' ).on( 'toggleAfter', ( event ) => {
        $( event.target ).next().slideToggle();
        const targets = $( event.target ).attr( 'data-toggle-target' ).split( ', ' );
        $( targets[1] ).fadeToggle( 1000 );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'short-accordions', COMPONENT );
} )( app );
